<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Book-Title--Front-Matter-" lang="en-US">Agent 355</p>
<p class="ORIM-Book-Subtitle--Front-Matter-" lang="en-US">A Novella</p>
<p class="ORIM-Author-Name--Front-Matter-" lang="en-US">Marie Benedict</p>
<p class="ORIM-Author-Name--Front-Matter-" lang="en-US"><img src="image/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?fd718018